// Mirror of the api `ErrorCodes` constants per ADR-0010 (standard error
// contract). All error bodies carry a stable `code` string the FE consumes
// for i18n toast keys.
export const ErrorCodes = {
  OPTIMISTIC_LOCK: 'OPTIMISTIC_LOCK',
  NOT_FOUND: 'NOT_FOUND',
  VALIDATION: 'VALIDATION',
  FORBIDDEN: 'FORBIDDEN',
  DELETE_REQUIRES_REASON: 'DELETE_REQUIRES_REASON',
  DELETE_BLOCKED_ASSIGNED: 'DELETE_BLOCKED_ASSIGNED',
  // CHR-06 §3 — a live place already holds that name (case-insensitive).
  PLACE_NAME_EXISTS: 'PLACE_NAME_EXISTS',
  INTERNAL: 'INTERNAL',
} as const;

export type ErrorCode = (typeof ErrorCodes)[keyof typeof ErrorCodes];
